const config = {
  test: {
    appid: 'wx5eb8abb782d660a9',
    coupon: {
      guliangquan: 17,
      feilongquan: 25
    },
    externalUrls: {
      downloadAndroidApp: '',
      downloadIOSApp: ''
    },
    authApi: {
      baseURL: 'https://dev-outspace.secon.cn/api/spero-auth-service'
    },
    lokiApi: {
      baseURL: 'https://dev-outspace.secon.cn/api/spero-loki-service'
    },
    smsApi: {
      baseURL: 'https://dev-outspace.secon.cn/api/spero-sms-service'
    },
    ultronApi: {
      baseURL: 'https://dev-outspace.secon.cn/api/spero-ultron-service'
    },
    activity: {
      enterURL: 'https://dev-h5.secon.cn/app-web/dev/#/gdfl2/5595'
    },
    jindashiApi: {
      baseURL: 'https://test-apigateway-v2.jindashi.cn/live-api'
    },
    saApi: {
      name: 'sa',
      web_url: 'http://test-sensors.baidao.com/?project=fm_duanshipin_test',
      server_url: 'https://test-sensors-api.baidao.com/sa?project=fm_duanshipin_test&token=aadh_123',
      heatmap: {
        clickmap: false
      },
      show_log: false
    },
    mqttConfig: {
      url: 'wss://dev-mqtt.secon.cn/mqtt',
      username: 'spero_dev_client',
      password: 'aFeZs2KZpC7W5c8mR8X4',
      env: 'dev',
      topic: '/spero/dev/live/room'
    },
    imChatMessage: {
      socket: 'wss://test-jdsim.jindashi.cn/ws',
      // username: 'spero_dev_client',
      key: '6PIRqVw3cRm84dKVgPlp',
      env: 'dev'
    },
    album: [308, 318],
    rootApi: {
      baseURL: 'https://dev-outspace.secon.cn'
    },
    adminApi: {
      baseURL: 'https://dev-outspace.secon.cn/api/spero-loki-service'
    },
    aliUpload: {
      bucket: 'gp-dev',
      endpoint: 'https://dev-oss.secon.cn',
      region: 'oss-cn-shanghai'
    }
  },
  preview: {
    appid: 'wx5eb8abb782d660a9',
    coupon: {
      guliangquan: 1,
      feilongquan: 2
    },
    authApi: {
      baseURL: 'https://spero-outspace.secon.cn/api/spero-auth-service'
    },
    lokiApi: {
      baseURL: 'https://spero-outspace.secon.cn/api/spero-loki-service-staging'
    },
    smsApi: {
      baseURL: 'https://spero-outspace.secon.cn/api/spero-sms-service'
    },
    ultronApi: {
      baseURL: 'https://spero-outspace.secon.cn/api/spero-ultron-service-staging'
    },
    activity: {
      enterURL: 'https://spero-h5.secon.cn/app-web/pre-release/#/gdfl2/13696'
    },
    jindashiApi: {
      baseURL: 'https://apigateway-v2.jindashi.cn/live-api'
    },
    saApi: {
      name: 'sa',
      web_url: 'http://sensors.baidao.com/?project=fm_duanshipin',
      server_url: 'https://jc-sensors.baidao.com/sa?project=fm_duanshipin&token=k30biu2q',
      heatmap: {
        clickmap: false
      },
      show_log: false
    },
    mqttConfig: {
      url: 'wss://spero-mqtt.secon.cn/mqtt',
      username: 'spero_prod_client',
      password: 'tXkbdRQDjxnnNW69LvfT',
      env: 'prod',
      topic: '/spero/prod/live/room'
    },
    imChatMessage: {
      socket: 'wss://jdsim.jindashi.cn/ws',
      // username: 'spero_dev_client',
      key: '6PIRqVw3cRm84dKVgPlp',
      env: 'prod'
    },
    album: [33, 192, 180, 191, 176],
    rootApi: {
      baseURL: 'https://spero-outspace.secon.cn'
    },
    adminApi: {
      baseURL: 'https://spero-outspace.secon.cn/api/spero-loki-service-staging'
    },
    aliUpload: {
      bucket: 'gp-prod',
      endpoint: 'https://oss.secon.cn',
      region: 'oss-cn-shanghai'
    }
  },
  production: {
    appid: 'wx5eb8abb782d660a9',
    coupon: {
      guliangquan: 1,
      feilongquan: 2
    },
    authApi: {
      baseURL: 'https://spero-outspace.secon.cn/api/spero-auth-service'
    },
    lokiApi: {
      baseURL: 'https://spero-outspace.secon.cn/api/spero-loki-service'
    },
    smsApi: {
      baseURL: 'https://spero-outspace.secon.cn/api/spero-sms-service'
    },
    ultronApi: {
      baseURL: 'https://spero-outspace.secon.cn/api/spero-ultron-service'
    },
    activity: {
      enterURL: 'https://spero-h5.secon.cn/app-web/#/gdfl2/13696'
    },
    jindashiApi: {
      baseURL: 'https://apigateway-v2.jindashi.cn/live-api'
    },
    saApi: {
      name: 'sa',
      web_url: 'http://sensors.baidao.com/?project=fm_duanshipin',
      server_url: 'https://jc-sensors.baidao.com/sa?project=fm_duanshipin&token=k30biu2q',
      heatmap: {
        clickmap: false
      },
      show_log: false
    },
    mqttConfig: {
      url: 'wss://spero-mqtt.secon.cn/mqtt',
      username: 'spero_prod_client',
      password: 'tXkbdRQDjxnnNW69LvfT',
      env: 'prod',
      topic: '/spero/prod/live/room'
    },
    imChatMessage: {
      socket: 'wss://jdsim.jindashi.cn/ws',
      // username: 'spero_dev_client',
      key: '6PIRqVw3cRm84dKVgPlp',
      env: 'prod'
    },
    album: [33, 192, 180, 191, 176],
    rootApi: {
      baseURL: 'https://spero-outspace.secon.cn'
    },
    adminApi: {
      baseURL: 'https://spero-outspace.secon.cn/api/spero-loki-service'
    },
    aliUpload: {
      bucket: 'gp-prod',
      endpoint: 'https://oss.secon.cn',
      region: 'oss-cn-shanghai'
    }
  }
}

export default config[process.env.ENV || 'test']



// WEBPACK FOOTER //
// ./src/config.js